import { render, staticRenderFns } from "./ParentSummary.vue?vue&type=template&id=26bed0a0&"
import script from "./ParentSummary.vue?vue&type=script&lang=js&"
export * from "./ParentSummary.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports